// @ts-ignore
import content from './md/building-a-referral-engine.md';

export const meta = {
  slug: 'building-a-referral-engine',
  title: 'Building a Referral Engine: How to Turn Every Completed Job Into 3 New Leads',
  excerpt: 'The best leads come from your existing customers. Learn how to build a systematic referral engine that turns happy customers into your best salespeople.',
  date: 'January 2025',
  readTime: '9 min read',
  image: '/docs/building-a-referral-engine/header.png'
};

export { content };
